const config = {
	/** @type Object<string, any> */
	initialValue: {
		amenities: [],
		area: { min: null, max: null },
		build_year: { min: null, max: null },
		building_floors_num: { min: null, max: null },
		building_type: [],
		business_type: [],
		/** @type {String | null} */
		description: null,
		/** @type {String | null} */
		destination: null,
		distance_to_subway: { min: null, max: null },
		city: ['Warszawa'],
		district: [],
		floor_num: { min: null, max: null },
		interior_standard: [],
		location_type: null,
		lat: null,
		lon: null,
		market: [],
		max_transport_time: null,
		offer_type: 'rent',
		offers_since: 'all-time',
		price: {
			min: null,
			max: null
		},
		price_change: [],
		radius: null,
		rooms_num: { min: null, max: null },
		subdistrict: [],
		transport_type: null,
		sort_by: 'accuracy',
		unit_price: { min: null, max: null }
	}
};

export default config;
